import { action, observable } from 'mobx'

class ImageModalHandler {
  @observable accessor imageUrls: string[] = []
  @observable accessor isOpen = false

  @action.bound openImageModal = (imageUrls: string[]) => {
    this.imageUrls = imageUrls
    this.isOpen = true
  }

  @action.bound closeImageModal = () => {
    this.imageUrls = []
    this.isOpen = false
  }
}

export default ImageModalHandler
